import { render, staticRenderFns } from "./wakenovelnotice.vue?vue&type=template&id=7c39a63b&scoped=true&"
import script from "./wakenovelnotice.vue?vue&type=script&lang=js&"
export * from "./wakenovelnotice.vue?vue&type=script&lang=js&"
import style0 from "./wakenovelnotice.vue?vue&type=style&index=0&id=7c39a63b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c39a63b",
  null
  
)

export default component.exports